import { formatDate } from './date';
import { formatLanguage, getOperatedInSummary, normalizeOperatedInLanguages } from './languages';
import { formatMoney, formatPriceValue } from './price';
import { formatTime } from './time';

export const format = {
  date: formatDate,
  language: formatLanguage,
  operatedInLanguages: normalizeOperatedInLanguages,
  operatedInSummary: getOperatedInSummary,
  /** Dynamic money formatting: amount + API currency. */
  money: formatMoney,
  priceValue: formatPriceValue,
  time: formatTime,
};

export { formatMoney, formatPriceValue };
